<template>
  <div>
    <v-card class="pa-10" elevation="0">
      <v-row>
        <v-col>
          <v-row no-gutters align="center">
            <h4 class="greyDark--text font-weight-bold mb-0">
              {{ $t('common:documentation_task_plural') }}
            </h4>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs}">
                <v-btn class="ml-2" icon @click="cardView = !cardView" v-bind="attrs" v-on="on">
                  <v-icon>list_alt</v-icon>
                </v-btn>
              </template>
              <span v-if="cardView">{{ $t('buttons:table-view') }}</span>
              <span v-else>{{ $t('buttons:card-view') }}</span>
            </v-tooltip>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <DocumentTab
            :facility-id = "$route.params.id"
            facility-mode
            :card-view="cardView"
        />
      </v-row>
    </v-card>
  </div>
</template>

<script>
import DocumentTab from '@/modules/book/views/task/dialog-components/DocumentTab.vue';

export default {
  name: 'FacilityTaskDocumentationTab',
  components: {DocumentTab},
  data() {
    return {
      cardView: true
    }
  }
}
</script>